import { USER_ROLE } from '@/types/user-role';

/**
 * Verifica se o usuário tem uma role de provider (PROVIDER, INDIVIDUAL, MASTER, SUB_PROVIDER)
 */
export function isProviderRole(role?: USER_ROLE): boolean {
  if (!role) return false;
  return (
    role === USER_ROLE.PROVIDER ||
    role === USER_ROLE.INDIVIDUAL ||
    role === USER_ROLE.MASTER ||
    role === USER_ROLE.SUB_PROVIDER
  );
}

/**
 * Verifica se o usuário é MASTER (dono da organização)
 */
export function isMasterRole(role?: USER_ROLE): boolean {
  return role === USER_ROLE.MASTER;
}

/**
 * Verifica se o usuário é SUB_PROVIDER (funcionário convidado)
 */
export function isSubProviderRole(role?: USER_ROLE): boolean {
  return role === USER_ROLE.SUB_PROVIDER;
}

/**
 * Verifica se o usuário é INDIVIDUAL (provider sem organização)
 */
export function isIndividualRole(role?: USER_ROLE): boolean {
  return role === USER_ROLE.INDIVIDUAL;
}

/**
 * Verifica se o usuário tem perfil de cliente (pode ter contratos como cliente)
 */
export function hasClientProfile(user: { clientProfile?: unknown } | null): boolean {
  return !!user?.clientProfile;
}

/**
 * Verifica se o usuário tem perfil de prestador
 */
export function hasProviderProfile(user: { providerProfile?: unknown } | null): boolean {
  return !!user?.providerProfile;
}

// Desativado: funcionalidade de um prestador também ser cliente (dual profile).
// Se o banco ainda tiver os dois perfis num mesmo usuário, prestador prevalece
// (ver isProviderRole/hasProviderProfile) e o front não trata mais o caso dual.
// export function hasDualProfile(user: {
//   clientProfile?: unknown;
//   providerProfile?: unknown;
// } | null): boolean {
//   return !!(user?.clientProfile && user?.providerProfile);
// }

type RoleUser = {
  role?: USER_ROLE;
  providerProfile?: unknown;
  clientProfile?: unknown;
} | null;

/**
 * Regra ÚNICA de "é prestador" no app. Antes cada lugar (sidebar, (tabs)/index,
 * _layout raiz, authStore) decidia sozinho — uns só pela role, outros pela role
 * OU pelo perfil — e o app mandava o mesmo usuário para homes diferentes.
 */
export function isProviderUser(user: RoleUser): boolean {
  return isProviderRole(user?.role) || hasProviderProfile(user ?? null);
}

/** Cliente é o complemento: prestador sempre prevalece (dual está desativado). */
export function isClientUser(user: RoleUser): boolean {
  if (isProviderUser(user)) return false;
  return user?.role === USER_ROLE.CLIENT || hasClientProfile(user ?? null);
}

export const PROVIDER_HOME_PATH = '/(tabs)/(provider)/home' as const;
export const CLIENT_HOME_PATH = '/(tabs)/(client)/hoje' as const;

/** Para onde este usuário vai quando o destino é "a home". */
export function getHomePathForUser(user: RoleUser) {
  return isProviderUser(user) ? PROVIDER_HOME_PATH : CLIENT_HOME_PATH;
}
